import React from 'react';

import { PACKET_FWD_ADDRESS_FIELDS } from '../../common/fields';
import TextInput from '../Controls/TextInput/TextInput';
import SelectInput from '../Controls/SelectField/SelectField';
import Description from '../Controls/Description/Description';
import SquareRadio from '../../../Controls/Buttons/SquareRadio/SquareRadio';
import {
    PACKET_FWD_PROTOCOL_OPTIONS,
    PACKET_FWD_TYPE_OPTIONS,
    PACKET_FWD_ADDRESS_OPTIONS
} from '@silverfort-nodelibs/common/utils/consts';
import styles from './RangeOrSubnet.module.css';
import inputStyles from '../Controls/TextInput/TextInput.module.css';
import SelectIpField from '../Controls/SelectIpField/SelectIpField';
const { ADDRESS_TYPE, RANGE_START, RANGE_END, SUBNET, PROTOCOL, TYPE, NOTES } = PACKET_FWD_ADDRESS_FIELDS;

const RangeOrSubnet = ({ field, changedFunc, maxSelectedSubnets }) => {
    const addressType = field[ADDRESS_TYPE.ID];
    const typeField = field[TYPE.ID];
    const subnet = field[SUBNET.ID];
    const rangeStart = field[RANGE_START.ID];
    const rangeEnd = field[RANGE_END.ID];
    const protocol = field[PROTOCOL.ID];
    const notes = field[NOTES.ID];

    const showDcRestartWarning = [addressType, typeField, subnet, rangeStart, rangeEnd, protocol].some(
        (field) => field.isDirty
    );

    const PROTOCOL_OPTIONS = Object.values(PACKET_FWD_PROTOCOL_OPTIONS).filter((protocol) => {
        return (
            (typeField.value === PACKET_FWD_TYPE_OPTIONS.source.value &&
                protocol.value === PACKET_FWD_PROTOCOL_OPTIONS.kerberos.value) ||
            (typeField.value === PACKET_FWD_TYPE_OPTIONS.dest.value &&
                protocol.value !== PACKET_FWD_PROTOCOL_OPTIONS.kerberos.value)
        );
    });

    const addressTypeChanged = (event) => {
        changedFunc(ADDRESS_TYPE.ID, event);
    };

    return (
        <>
            <div className={styles.options}>
                <SquareRadio
                    handleSquareRadioChange={addressTypeChanged}
                    valuesList={Object.values(PACKET_FWD_ADDRESS_OPTIONS)}
                    radioValue={addressType.value}
                />
            </div>

            <div
                className={addressType.value === PACKET_FWD_ADDRESS_OPTIONS.range.value ? styles.range : styles.subnet}>
                {addressType.value === PACKET_FWD_ADDRESS_OPTIONS.range.value && (
                    <div>
                        <div className={styles.rangeFields}>
                            <TextInput
                                field={{ ...rangeStart, desc: '', error: '' }}
                                placeholder="127.0.0.1"
                                color="grey"
                                changed={changedFunc}
                            />
                            <div className={styles.separator}>-</div>
                            <TextInput
                                field={{ ...rangeEnd, error: '' }}
                                placeholder="127.0.0.1"
                                color="grey"
                                changed={changedFunc}
                            />
                        </div>

                        {rangeStart.error && <div className={inputStyles.errorText}>{rangeStart.error}</div>}
                        {rangeEnd.error && <div className={inputStyles.errorText}>{rangeEnd.error}</div>}
                        {rangeStart.desc && <Description value={rangeStart.desc} />}
                    </div>
                )}
                {addressType.value === PACKET_FWD_ADDRESS_OPTIONS.subnet.value && (
                    <SelectIpField field={subnet} changed={changedFunc} maxIps={20} />
                )}
                <SelectInput
                    field={{
                        ...typeField,
                        name: TYPE.NAME
                    }}
                    color="grey"
                    changed={changedFunc}
                    options={Object.values(PACKET_FWD_TYPE_OPTIONS)}
                />
            </div>
            <div className={styles.range}>
                <SelectInput
                    field={protocol}
                    color="grey"
                    changed={changedFunc}
                    multichoice
                    options={PROTOCOL_OPTIONS}
                />
                <TextInput field={notes} color="grey" changed={changedFunc} />
            </div>
            {showDcRestartWarning && (
                <div className={`${styles.range} ${styles.notificationText}`}>
                    <div>Warning: This change will restart the AD Adapter</div>
                </div>
            )}
        </>
    );
};

export default React.memo(RangeOrSubnet);
